import * as React from "react";
import {ISymptom} from "@curefit/care-common";
import TemplatedList from "../../TemplatedList"
import ModelFactory from "../../../models/ModelFactory"
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader"
import {AppPlaceholders, SymptomTypes} from "../../../utils/AppConstants";
import TextAreaAutoResize from "../../TextAreaAutoResize";
import {ChangeEvent} from "react";
import {isEmpty as _isEmpty} from "lodash"

/**
 * Created by aditya on 26/02/18.
 */

let PresentingIllnessEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "presentingIllness", display: "HISTORY OF PRESENTING ILLNESS"},
    {label: "days", display: "NO. OF DAYS"},
    {label: "attributes", display: "ATTRIBUTES (IF ANY)"}
];


export interface PatientIllnessEditorProps {
    updatedHopis: {item: string},
    updatedIllnesses: {item: ISymptom}[],
    fetchStaticSymptoms: (input: string) => Promise<any>,
    updateIllnesses: (updatedSymptoms: {item: ISymptom}[]) => void,
    updateHopi: (updatedHopi: {item: string}) => void
}

class PatientIllnessesEditor extends React.Component<PatientIllnessEditorProps> {

    constructor(props: PatientIllnessEditorProps) {
        super(props);
    }

    onIllnessRemove = (index: number) => {
        let currUpdatedSymptoms = Object.assign([], this.props.updatedIllnesses);
        currUpdatedSymptoms.splice(index, 1);
        this.props.updateIllnesses(currUpdatedSymptoms);
    }

    onIllnessChange = (updatedSymptom: ISymptom, index: number) => {
        let currUpdatedSymptoms = Object.assign([], this.props.updatedIllnesses);
        currUpdatedSymptoms[index] = updatedSymptom;
        this.props.updateIllnesses(currUpdatedSymptoms);
    }

    onHOPIChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        let currUpdatedIllnesses = {item: event.target.value};
        this.props.updateHopi(currUpdatedIllnesses);
    }

    render() {
        let customHeader = PresentingIllnessEditorHeaderInfos;
        let illnessText = !_isEmpty(this.props.updatedHopis) ? this.props.updatedHopis.item : "";
        return (
            <div className="patient-symptom-editor">
                <CustomHeader headerInfos={PresentingIllnessEditorHeaderInfos} rootCls={"patient-symptom"}/>
                <TemplatedList templateName={"symptom"} commonProps={{fetchSymptomByName: this.props.fetchStaticSymptoms}}
                               defaultItem={{item: ModelFactory.createNewSymptom()}}
                               listItems={this.props.updatedIllnesses}
                               onItemRemove={this.onIllnessRemove}
                               onItemChange={this.onIllnessChange}/>
                <TextAreaAutoResize
                    name={"patient-illness-text"}
                    rows={3}
                    className={"patient-illness-text"}
                    placeholder={AppPlaceholders.SYMPTOMS_EDITVIEW_ILLNESSES}
                    onChange={this.onHOPIChange}
                    value={illnessText} />
            </div>
        );
    }
}

export default PatientIllnessesEditor